(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("foldcontent", [], factory);
	else if(typeof exports === 'object')
		exports["foldcontent"] = factory();
	else
		root["foldcontent"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	__webpack_require__(1);
	(function () {
	    var foldcontent = function () {
	        function foldcontent(option) {
	            _classCallCheck(this, foldcontent);
	
	            var defaultOption = {
	                container: document.getElementsByClassName('foldcontent-panel'),
	                btnBg: '#eff6fa',
	                btnColor: '#0c5897',
	                fixBtnBg: '#81baeb',
	                fixBtnColor: '#fff',
	                fontSize: '12px',
	                padding: '5px',
	                initialText: '展开',
	                fixText: '收起',
	                bottom: '15px',
	                right: '20px',
	                lineHeight: '1'
	            };
	            for (var defauleKey in defaultOption) {
	                if (defaultOption.hasOwnProperty(defauleKey) && !option.hasOwnProperty(defauleKey)) {
	                    option[defauleKey] = defaultOption[defauleKey];
	                }
	            }
	            this.container = option.container;
	            this.init(option);
	        }
	
	        _createClass(foldcontent, [{
	            key: 'init',
	            value: function init(option) {
	                var _this = this;
	
	                var doc = document,
	                    win = window,
	                    fold = doc.getElementsByClassName('unfold'),
	                    btnRight = parseInt(option.right),
	                    initialText = option.initialText,
	                    fixText = option.fixText;
	
	                var html = '<div class="unfold" style="background-color: ' + option.btnBg + '; color: ' + option.btnColor + '; font-size: ' + (parseInt(option.fontSize) + 'px') + ';\n line-height: ' + option.lineHeight + '; right: ' + option.right + ';bottom: ' + option.bottom + '; padding: ' + option.padding + ';">' + option.initialText + '</div>';
	                Array.from(this.container).forEach(function (i) {
	                    i.innerHTML += html;
	                });
	
	                var _loop = function _loop(i) {
	                    fold[i].addEventListener('click', function (e) {
	                        var target = e.target,
	                            part = doc.getElementsByClassName('part-content')[i],
	                            all = doc.getElementsByClassName('all-content')[i],
	                            btnBottom = parseInt(target.style.padding);
	                        if (target.innerHTML !== fixText) {
	                            (function () {
	                                target.innerHTML = fixText;
	                                _this.toggle(part, all);
	                                var panel = target.parentNode,
	                                    panelWidth = parseInt(window.getComputedStyle(panel, null).getPropertyValue('width')),
	                                    h = win.innerHeight || doc.documentElement.clientHeight || doc.body.clientHeight || 0,
	                                    w = doc.documentElement.getBoundingClientRect().width || 0,
	
	                                // jquery width() 方法, 不包含滚动条宽度 vs document.body.clientWidth == document.body.offsetWidth  window.innerWidth)
	                                s = win.pageYOffset || doc.body.scrollTop || doc.documentElement.scrollTop || 0;
	                                h = h + s;
	                                var t = panel.offsetTop,
	                                    p = panel.offsetParent;
	                                while (p !== null) {
	                                    t += p.offsetTop;
	                                    p = p.offsetParent;
	                                }
	                                t += panel.clientHeight;
	                                var right = (w - panelWidth) / 2 + btnRight > btnRight ? (w - panelWidth) / 2 + btnRight : btnRight,
	                                    allContent = document.getElementsByClassName('all-content')[i],
	                                    allShow = allContent.style.display;
	                                if (h - t < btnBottom) {
	                                    var fixBtn = doc.querySelector('.fix-btn');
	                                    if (fixBtn) {
	                                        _this.changeStyle(fixBtn, option);
	                                    }
	                                    target.style.right = right + 'px';
	                                    _this.changeFix(target, option);
	                                    if (allShow === 'block') {
	                                        target.classList.add('slide-btn');
	                                    }
	                                }
	                                var cb = {
	                                    onscroll: function onscroll() {
	                                        var h = win.innerHeight || doc.documentElement.clientHeight || doc.body.clientHeight || 0,
	                                            w = doc.documentElement.getBoundingClientRect().width || 0,
	                                            s = win.pageYOffset || doc.body.scrollTop || doc.documentElement.scrollTop || 0;
	                                        h = h + s;
	                                        var t = panel.offsetTop,
	                                            p = panel.offsetParent;
	                                        while (p !== null) {
	                                            t += p.offsetTop;
	                                            p = p.offsetParent;
	                                        }
	                                        var th = t + panel.clientHeight,
	                                            right = (w - panelWidth) / 2 + btnRight > btnRight ? (w - panelWidth) / 2 + btnRight : btnRight,
	                                            allContent = document.getElementsByClassName('all-content')[i],
	                                            allShow = allContent.style.display;
	
	                                        if (th - h > 0 && h - t > 90 && target.innerHTML !== initialText) {
	                                            target.style.right = right + 'px';
	                                            _this.changeFix(target, option);
	                                            if (allShow === 'block') {
	                                                target.classList.remove('slide-btn');
	                                            }
	                                        } else {
	                                            _this.changeStyle(target, option);
	                                            // target.classList.add('slide-btn')
	                                        }
	                                        doc.removeEventListener("scroll", cb.onscroll, false);
	                                        setTimeout(function () {
	                                            doc.addEventListener("scroll", cb.onscroll);
	                                        }, 50);
	                                    }
	                                };
	                                doc.addEventListener('scroll', cb.onscroll, false);
	                            })();
	                        } else {
	                            _this.changeStyle(target, option);
	                            target.innerHTML = initialText;
	                            _this.toggle(part, all);
	                        }
	                    });
	                };
	
	                for (var i = 0; i < fold.length; i++) {
	                    _loop(i);
	                }
	            }
	            // ES6 布丁参数, 停止使用 arguments
	
	        }, {
	            key: 'toggle',
	            value: function toggle() {
	                for (var _len = arguments.length, list = Array(_len), _key = 0; _key < _len; _key++) {
	                    list[_key] = arguments[_key];
	                }
	
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var i = _step.value;
	
	                        if (window.getComputedStyle(i, null).getPropertyValue('display') !== 'none') {
	                            i.style.display = 'none';
	                        } else {
	                            i.style.display = 'block';
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	        }, {
	            key: 'changeStyle',
	            value: function changeStyle(i, option) {
	                var style = i.style;
	                style.right = option.right;
	                style.color = option.btnColor;
	                style.backgroundColor = option.btnBg;
	                style.position = 'absolute';
	                i.classList.remove('fix-btn');
	            }
	        }, {
	            key: 'changeFix',
	            value: function changeFix(i, option) {
	                var style = i.style;
	                style.color = option.fixBtnColor;
	                style.backgroundColor = option.fixBtnBg;
	                style.position = 'fixed';
	                i.classList.add('fix-btn');
	            }
	        }]);
	
	        return foldcontent;
	    }();
	
	    if (typeof module !== "undefined" && typeof module.exports !== "undefined") {
	        module.exports = foldcontent;
	    } else {
	        window.foldContent = foldcontent;
	    }
	})();
	// todo: 收起一个 div 时判断下一个 div 是否显示固定定位按钮; 添加按钮在固定定位、绝对定位状态切换时的动画效果

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(2);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../node_modules/css-loader/index.js!./style.css", function() {
				var newContent = require("!!./../node_modules/css-loader/index.js!./style.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".foldcontent-panel{box-sizing:border-box;position:relative;width:700px;margin:20px auto;padding:30px;color:#666;line-height:2.5;border:1px solid #eee;box-shadow:5px 6px 5px #ccc}.all-content{display:none}.unfold{position:absolute;border-radius:5px;cursor:pointer}.slide-btn{animation:foldSlide .1s ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both}@-webkit-keyframes foldSlide{0%{bottom:0}to{bottom:15px}}@keyframes foldSlide{0%{bottom:0}to{bottom:15px}}", ""]);
	
	// exports


/***/ },
/* 3 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }
/******/ ])
});
;


// WEBPACK FOOTER //
// foldcontent.min.js